import { JsonPipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BreadCrumb } from 'src/app/models/breadcrumb.model';
import { AssessmentmanagerService } from 'src/app/services/assessments/assessmentmanager.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { NotificationService } from 'src/app/services/interceptor/notification';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-score-assessment',
  templateUrl: './score-assessment.component.html',
  styleUrls: ['./score-assessment.component.css'],
})
export class ScoreAssessmentComponent implements OnInit, AfterViewInit {
  @ViewChild('answerPane') answerPane: ElementRef;

  assessment: any = {};
  assessmentname: string;
  assessmentID: number;
  confirmAssessmentdelete = false;
  confirmQuestiondelete = false;
  errormessage: string;
  classID: number;
  loading: string;
  breadcrumbs: BreadCrumb[] = [];
  questions: string[];
  fileQuestionDisplay: any;
  studentID: number;
  isPdf: boolean = false;
  pdfData: string;
  isImage: boolean = false;
  imageData: string;
  pdfpreview: boolean = false;
  selectedImage: string =
    'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
  batchid: number;
  essayTextExceeded: boolean;

  constructor(
    private activatedroute: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    public assessmentManager: AssessmentmanagerService,
    public sanitizer: DomSanitizer,
    public header: ComponentheaderService,
    private notification: NotificationService, private utilservice: UtilService
  ) {
    this.assessmentname = 'Loading Assessment...';
    this.header.setHeaderDisplay('Assessment Submission Detail', [], []);
  }

  ngOnInit(): void {
    this.assessmentID = this.activatedroute.snapshot.queryParams.aid;
    this.studentID = this.activatedroute.snapshot.queryParams.stid;
    this.classID = this.activatedroute.snapshot.queryParams.classid;
    let moduleid = this.activatedroute.snapshot.queryParams.moduleid;
    this.batchid = this.activatedroute.snapshot.queryParams.batchid;

    this.notification.currentNotificationType =
      this.notification.CALL_TYPE.SIMPLE_PAGE_LOAD_GET_CONTENT;
    this.assessmentManager
      .getAssessmentDetails_scoringview(this.assessmentID, this.studentID,moduleid)
      .toPromise()
      .then((response: any) => {
        this.assessment = response.data;
        this.assessmentname = response.data.name;
        localStorage.setItem(
          this.assessmentManager.LocalStorage_FLAG.questionType,
          this.assessment.questionType
        );
        localStorage.setItem(
          this.assessmentManager.LocalStorage_FLAG.AssesmentTitle,
          this.assessment.name
        );
        localStorage.setItem(
          this.assessmentManager.LocalStorage_FLAG.deliveryType,
          response.data.timedType
        );
        localStorage.setItem(
          this.assessmentManager.LocalStorage_FLAG.currentAssessmentCache,
          JSON.stringify(response.data)
        );
        //call this for only file assessments with only one questions
        if (
          this.assessment.questionType ==
          this.assessmentManager.QuestionTypeFlags.fileQuestionFlag
        ) {
          this.assessmentManager
            .getAssessmentFile(this.assessment.questions[0].id, this.studentID)
            .toPromise()
            .then((data: any) => {
              //debugger;
              var elements = [];
              this.fileQuestionDisplay = data.files[0];
              // this.selectedImage=;
              let fileType = this.fileQuestionDisplay.name.split('.').pop();
              if (
                fileType === 'jpeg' ||
                fileType === 'jpg' ||
                fileType === 'png'
              ) {
                this.isImage = true;
                this.imageData = this.fileQuestionDisplay.link;
              }
              if (fileType === 'pdf') {
                this.isPdf = true;
                this.pdfData = this.fileQuestionDisplay.link;
              }
            });
        }

        this.header.setHeaderDisplay(
          'Assessment Submission Detail',
          [
            {
              displaytext: 'School',
              route: `/user/schoolhome`,
              params: { schoolID: response.breadcrumb.schoolID }
            },
            {
              displaytext: 'Course',
              route: `/user/moduledetails`,
              params: { moduleID: response.breadcrumb.moduleID }
            },
            {
              displaytext: 'Lesson' ,
              route: `/user/lesson`,
              params: { classid: this.classID }
            },
            {
              displaytext: "Assessments",
              route: `/user/assessmentconsole`,
              params: { classid: this.classID, batchid: this.batchid }
            },
            {
              displaytext: response.breadcrumb.assessmentName,
              route: `/user/assessmentdetails`,
              params: { classid: this.classID, aid: response.breadcrumb.assessmentID, batchid: this.batchid },
            },
            {
              displaytext: 'Submissions',
              route: `/user/assessmentsubmissions`,
              params: { aid: this.assessmentID, classid: this.classID, batchid: this.batchid },
            },
            {
              displaytext: `Submission by ${this.assessment.studentName}`,
              route: `/user/scoreassessment`,
              params: { aid: this.assessmentID, stid: this.studentID, classid: this.classID, batchid: this.batchid },
            },
          ],
          []
        );
      });
  }

  ngAfterViewInit(): void {
    let pane = this.answerPane.nativeElement as HTMLElement;
  }

  async saveAssessment() {
    let questionScoreString = '[';
    let studentScorePane = this.answerPane.nativeElement as HTMLElement;

    let scoreinputs = studentScorePane.getElementsByClassName('scoreInputItem');
    let commentinputs = studentScorePane.getElementsByClassName('commentInputItem');
    let count = 0;
    Array.from(scoreinputs).forEach((item) => {
      let inputItem = item as HTMLInputElement;
      let commentItem = commentinputs[count] as HTMLInputElement;
      count++;
      let answerText = '';

      if (
        this.assessment.questionType ==
        this.assessmentManager.QuestionTypeFlags.essayQuestionFlag
      ) {
        let quilDiv = inputItem.parentElement.parentElement.parentElement
          .getElementsByClassName('ql-editor')
          .item(0) as HTMLElement;
        answerText = quilDiv.innerHTML;
      }

      questionScoreString += `{"stdID":${this.studentID},
                                  "questionID":${Number.parseInt(
        item.getAttribute('id')
      )},
                                  "questiontype":"${
        this.assessment.questionType
        }",
                                  "assessmentID":${this.assessmentID},
                                  "score": ${Number.parseFloat(inputItem.value)},
                                  "markedText": "${answerText}",
                                  "std" : "${this.assessment.student}",
                                  "comment": "${commentItem.value}"
                                },`;
    });

    questionScoreString =
      questionScoreString
        .slice(0, questionScoreString.length - 1)
        .replace(/NaN/g, '999') + ']';

    if (questionScoreString.length > 5) {
      let questionAnswerObject = JSON.parse(questionScoreString);
      console.log(questionAnswerObject);
      this.assessmentManager
        .submitAssessmentMarking(questionAnswerObject)
        .toPromise()
        .then((data: any) => {
          this.toastr.success('Assessment Submission Scored');
          this.router.navigate(['/user/assessmentsubmissions'], {
            queryParams: { classid: this.classID, aid: this.assessmentID, batchid: this.batchid },
          });
        });
    }
  }

  pdfpreviewChange() {
    this.pdfpreview = !this.pdfpreview;
  }

  async allowRetake(allow: boolean = true){
    let confirm = false;
    if (allow)
      confirm = await this.utilservice.confirm('Previous Assessment record will be deleted permanently after Student retake', 'Do you wish to continue?');
    else
      confirm = await this.utilservice.confirm('You are about to cancel Assessment retake', 'Do you wish to continue?');

    if(confirm){
      this.header.pageLoadingStarted(this);
      let data = {assessmentid:this.assessmentID, submissionid: this.assessment.submissionid, userid:this.studentID, allowrewrite: allow};
      await this.assessmentManager.allowAssessmentRetake((data)).toPromise().then(
        (data: any) => {
          this.header.pageLoadingDone(this);
          this.assessment.allowRetake = data;
          if(allow){
            this.toastr.success("Retake Allowed");
          }
          else{
            this.toastr.success("Retake Cancelled");
          }
          //this.router.navigate(['/user/assessmentsubmissions'], {queryParams: {classid: this.classID, aid: this.assessmentID}});
        },
      ).catch((error) => {
        console.error(error);
        this.header.pageLoadingDone(this);
        this.toastr.error('An error occured');
      });
    }
  }

  handleTextExceeded(data: any) {    
    this.essayTextExceeded = data.exceed;
    let q = this.assessment.questions.find(question => question.id === data.id);
    // this is used for updating the pagination buttons to indicate red
    q.isValid = data.exceed ? 0 : 1;    
  }
}
